import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BusinessPartnerBackofficeModuleState } from '../../models/business-partner-backoffice.model';

export const getBusinessPartnerBackofficeModuleState =
  createFeatureSelector<BusinessPartnerBackofficeModuleState>('businessPartnerBackofficeModule');

export const selectBusinessPartners = createSelector(
  getBusinessPartnerBackofficeModuleState,
  (state) => state.businessPartners,
);

export const getBusinessPartners = createSelector(
  getBusinessPartnerBackofficeModuleState,
  (state) => state.businessPartners,
);

export const getBusinessPartnerPagination = createSelector(
  getBusinessPartnerBackofficeModuleState,
  (state) =>
    state.pagination || {
      pageNumber: null,
      pageSize: null,
      totalNumberOfItems: null,
    },
);

export const getBusinessPartnerPageNumber = createSelector(
  getBusinessPartnerPagination,
  (pagination) => pagination.pageNumber,
);
export const getBusinessPartnerPageSize = createSelector(
  getBusinessPartnerPagination,
  (pagination) => pagination.pageSize,
);
export const getBusinessPartnerTotalNumberOfItems = createSelector(
  getBusinessPartnerPagination,
  (pagination) => pagination.totalNumberOfItems,
);
